<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue'

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectLabel,
  SelectItem,
} from "@/components/ui/select"

import { get_data_attr, sortDropdownOptions } from '@/utils/globals'
import { useViewStore } from '@/stores/viewStore'

type SelectItemType = {
  value: string | number
  label: string
}

const props = defineProps<{
  items?: SelectItemType[]
  modelValue?: string | number | null
}>()

const emit = defineEmits<{
  (e: "update:modelValue", value: string | number): void
  (e: "change", value: string | number): void
}>()

const viewStore = useViewStore()

const items = computed(() => {
  const baseItems = sortDropdownOptions(props.items ?? get_data_attr("standorts"))
  return props.items && props.items.length > 0
    ? sortDropdownOptions([{ value: -1, label: "Global" }, ...baseItems])
    : baseItems
})
const isGlobalStandortSelect = computed(() => !props.items)
const selected = ref<string | number | null>(
  isGlobalStandortSelect.value ? viewStore.currentStandort : (props.modelValue ?? null)
)
const syncingFromModel = ref(false)

watch(
  () => props.modelValue,
  (newVal) => {
    if (isGlobalStandortSelect.value || newVal === undefined || selected.value === newVal) return
    syncingFromModel.value = true
    selected.value = newVal
    nextTick(() => {
      syncingFromModel.value = false
    })
  }
)

watch(selected, (newVal, oldVal) => {
  if (newVal === null || newVal === oldVal) return
  if (syncingFromModel.value) return

  if (isGlobalStandortSelect.value) {
    viewStore.setCurrentStandort(newVal)
    window.location.href = `?session_id=-1&standort_id=${newVal}`
    return
  }

  emit("update:modelValue", newVal)
  emit("change", newVal)
})
</script>

<template>
  <div class="hoeppner-bg-white h-10">
    <Select v-model="selected">
      <SelectTrigger>
        <SelectValue placeholder="Standort..." />
      </SelectTrigger>

      <SelectContent class="z-[10002]">
        <SelectGroup>
          <SelectLabel>Standort Selektion</SelectLabel>

          <SelectItem
            v-for="item in items"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </SelectItem>

        </SelectGroup>
      </SelectContent>
    </Select>
  </div>
</template>
